import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { GenericHttpService } from "./../../../../services/generic-http.service";
import { environment } from "./../../../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class DropDownService {
  constructor(private generic: GenericHttpService) {}
  apiUrl = environment.baseUrl;

  getDropDownData(option) {
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.generic.responseData)
    );
  }
}
